<template>
  <div>
    <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
      <v-tab> دروس کسری </v-tab>
      <v-tab> دروس انتخاب شده </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div
          class="courses"
          :style="[notPassed.length == 0 ? { 'padding-bottom': '0' } : '']"
        >
          <div class="notFound" v-if="notPassed.length == 0">
            درس کسری در این پایه وجود ندارد
          </div>
          <v-card v-else v-for="(item, key) in notPassed" :key="key">
            <v-card-title class="info-detail">
              <div class="text-center">
                {{ item.Name }}
              </div>
            </v-card-title>
            <div>
              <app-row icon="file-excel" title="کد درس: " :value="item.ID" />
              <app-row
                icon="hashtag"
                title="تعداد واحد: "
                :value="item.Vahed"
              />
              <app-row icon="clock" title="ساعت: " :value="item.Saat" />
            </div>
          </v-card>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div
          class="courses"
          :style="[courses.length == 0 ? { 'padding-bottom': '0' } : '']"
        >
          <div class="notFound" v-if="courses.length == 0">
            درس انتخاب شده در این پایه وجود ندارد
          </div>
          <v-card
            v-else
            v-for="key in courses.length"
            :key="key"
            :index="key - 1"
            @click="toggleExpansion(key - 1)"
          >
            <v-card-title class="info-detail">
              <font-awesome-icon
                class="collapse"
                :icon="getCourseIcon(key - 1)"
              />
              <div class="text-center text-padding">
                {{ courses[key - 1].TitleName }}
              </div>
            </v-card-title>
            <div>
              <app-row
                icon="file-excel"
                title="نمره: "
                :value="courses[key - 1].Score"
              />
              <app-row
                icon="question-circle"
                title="وضعیت: "
                :value="courses[key - 1].State"
              />
              <div v-if="selectedVahed == key - 1">
                <app-row
                  icon="book"
                  title="کد درس:"
                  :value="courses[key - 1].ID"
                />
                <app-row
                  icon="book"
                  title="پایه:"
                  :value="courses[key - 1].PayehName"
                />
                <app-row
                  icon="university"
                  title="واحد:"
                  :value="courses[key - 1].Vahed"
                />
                <app-row
                  icon="file-excel"
                  title="نمره 1:"
                  :value="courses[key - 1].Score1"
                />
                <app-row
                  icon="file-excel"
                  title="نمره 2:"
                  :value="courses[key - 1].Score2"
                />
                <app-row
                  icon="file-excel"
                  title="نمره 3:"
                  :value="courses[key - 1].Score3"
                />
                <app-row
                  icon="file-excel"
                  title="نمره شفاهی:"
                  :value="courses[key - 1].ScoreShafahi"
                />
                <app-row
                  icon="file-excel"
                  title="نمره تحقیق:"
                  :value="courses[key - 1].ScoreResearch"
                />
              </div>
            </div>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  data() {
    return {
      tab: null,
      items: ["دروس کسری", "دروس انتخاب شده"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    };
  },
  props: ["payeh", "selectedVahed"],
  components: {
    appRow: DetailRow,
  },
  computed: {
    courses() {
      return this.payeh.TitlePassed;
    },
    notPassed() {
      return this.payeh.TitleNotPassed;
    },
  },

  methods: {
    getCourseIcon(index) {
      return this.selectedVahed == index ? "angle-down" : "angle-left";
    },
    toggleExpansion(key) {
      this.$emit("clickedVahed", key);
    },
  },
};
</script>
<style scoped>
.notFound {
  background-color: white;
  padding: 20px;
}
.courses {
  background-color: white !important;
}
</style>
